import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as categoriesActions from './categories-actions';;
import { catchError, map, switchMap, takeUntil} from 'rxjs/operators';
import { of } from 'rxjs';
import { CategoryService } from '@app/marketplace/categories/_services/category.service';

@Injectable()
export class CategoriesEffects {

  constructor(
    private actions$: Actions,
    private service: CategoryService) { }

  loadCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoriesActions.LIST_CATEGORIES, categoriesActions.CANCEL_CATEGORIES_REQUEST),
      switchMap((action: any) => {
        return this.service.ListCategories(action.payload).pipe(
          takeUntil(this.actions$.pipe(ofType(categoriesActions.CANCEL_CATEGORIES_REQUEST))),
          map((data: any) => {
            data.count = data.data.length;
            return ({ type: categoriesActions.LIST_CATEGORIES_SUCCESS, data });
          }),
          catchError((error) => {
            return of({ type: categoriesActions.LIST_CATEGORIES_FAILURE });
          })
        );
      })
    )
  );
}
